import { type UseQueryResult, useQuery } from 'react-query';
import {
  ParticipantSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_Participant_ViewParticipantAddressDto,
} from '../../services/wealthlane-customer-services';

const useGetParticipantAddressDetails = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_Participant_ViewParticipantAddressDto | undefined,
  unknown
> => {
  const participantAddressDetails = useQuery(['getParticipantAddressDetails'], async () => {
    return await handleRequest(
      ParticipantSharedService.getApiCustomerApiAppParticipantParticipantAddress()
    );
  });

  return participantAddressDetails;
};

export default useGetParticipantAddressDetails;
